import { initWorkCardTapAbTest } from '@common/utils/workCardTapTransition'

// 求人カードタップ時アニメーションABテストの振り分け+計測。
// works entrypointに置くとkeepings等の別ページでも計測されて母集団が汚れるため専用entrypointにしている
initWorkCardTapAbTest()
